
import { LookupCategoryDto as AccountLookupCategoryDto } from "../../services/dto/account/lookupCategoryDto";
import { LookupCategoryDto as AdminLookupCategoryDto } from "../../services/dto/admin/lookupCategoryDto";
import { LookupCategoryDto as PopHubLookupCategoryDto } from "../../services/dto/popHub/lookupCategoryDto";
import { LookupCategoryDto as SystemLookupCategoryDto } from "../../services/dto/system/lookupCategoryDto";

import { LookupGroupDto as AccountLookupGroupDto } from "../../services/dto/account/lookupGroupDto";
import { LookupGroupDto as AdminLookupGroupDto } from "../../services/dto/admin/lookupGroupDto";
import { LookupGroupDto as PopHubLookupGroupDto } from "../../services/dto/popHub/lookupGroupDto";
import { LookupGroupDto as SystemLookupGroupDto } from "../../services/dto/system/lookupGroupDto";

import { LookupDto as AccountLookupDto } from "../../services/dto/account/lookupDto";
import { LookupDto as AdminLookupDto } from "../../services/dto/admin/lookupDto";
import { LookupDto as PopHubLookupDto } from "../../assets/utils/lib/lookupDto";
import { LookupDto as SystemLookupDto } from "../../services/dto/system/lookupDto";

import { QueryKeyTypes } from "../../assets/types/common";
import { Constants } from "../../assets/utils/lib/constants";

export namespace ViewProps {

    export type CategoryTypeDto =
        SystemLookupCategoryDto
        | AccountLookupCategoryDto
        | AdminLookupCategoryDto
        | PopHubLookupCategoryDto;

    export type GroupTypeDto =
        SystemLookupGroupDto
        | AccountLookupGroupDto
        | AdminLookupGroupDto
        | PopHubLookupGroupDto;

    export type ValueTypeDto = SystemLookupDto | AccountLookupDto | AdminLookupDto | PopHubLookupDto;

    export const LookupGroupQueryKeys: Record<QueryKeyTypes, string> = {
        [QueryKeyTypes.None]: Constants.emptyString,
        [QueryKeyTypes.Get]: "lookupGroupQuery",
        [QueryKeyTypes.Grid]: "lookupGroupGridQuery",
        [QueryKeyTypes.Lookup]: "lookupsQuery",
        [QueryKeyTypes.GetAll]: "lookupGroupsQuery",
    }

    export enum LookupTypeQueryTypes {
        None,
        Get,
        Grid,
        GetAll,
        GetALLByType
    }

    export const LookupTypeQueryKeys: Record<LookupTypeQueryTypes, string> = {
        [LookupTypeQueryTypes.None]: Constants.emptyString,
        [LookupTypeQueryTypes.Get]: "lookupTypeQuery",
        [LookupTypeQueryTypes.Grid]: "lookupTypeGridQuery",
        [LookupTypeQueryTypes.GetALLByType]: "lookupTypesQuery",
        [LookupTypeQueryTypes.GetAll]: "allLookupTypesQuery",
    }

    export enum LookupValueQueryTypes {
        None,
        Get,
        GetAll,
        GetLookupTypes_Lookup,
        GetLookupGroups_Lookup,
        Grid
    }

    export const LookupValueQueryKeys: Record<LookupValueQueryTypes, string> = {
        [LookupValueQueryTypes.None]: Constants.emptyString,
        [LookupValueQueryTypes.Get]: "lookupValueQuery",
        [LookupValueQueryTypes.Grid]: "lookupValueGridQuery",
        [LookupValueQueryTypes.GetAll]: "lookupValuesQuery",
        [LookupValueQueryTypes.GetLookupTypes_Lookup]: "lookupTypesAsLookupQuery",
        [LookupValueQueryTypes.GetLookupGroups_Lookup]: "lookupGroupAsLookupQuery"
    }
}